/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PostGroupManagerCreatePostGroupRequest } from "../models/PostGroupManagerCreatePostGroupRequest";
import type { PostGroupManagerCreatePostGroupResponseApiRespoonse } from "../models/PostGroupManagerCreatePostGroupResponseApiRespoonse";
import type { PostGroupManagerListPostGroupRequest } from "../models/PostGroupManagerListPostGroupRequest";
import type { PostGroupManagerListPostGroupResponseApiRespoonse } from "../models/PostGroupManagerListPostGroupResponseApiRespoonse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class PostGroupMangerService {
  /**
   * List post group
   * @param requestBody
   * @returns PostGroupManagerListPostGroupResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static postGroup(
    requestBody: PostGroupManagerListPostGroupRequest
  ): CancelablePromise<PostGroupManagerListPostGroupResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/post_group",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Create post group
   * @param requestBody
   * @returns PostGroupManagerCreatePostGroupResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static postGroupCreate(
    requestBody: PostGroupManagerCreatePostGroupRequest
  ): CancelablePromise<PostGroupManagerCreatePostGroupResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/post_group/create",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }
}
